import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import OutOfTheOfficeAlertContainer from '../../../shared/containers/OutOfTheOfficeAlertContainer';
import { HUBSPOTTER } from '../../constants/OwnerType';
import NotesTextArea from '../../components/fields/NotesTextArea';
import ReasonForEscalationSelect from '../../components/fields/ReasonForEscalationSelect';
import { saveEscalation } from '../../actions/EscalationActions';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function AccountManagerEscalation() {
  const dispatch = useDispatch();
  const escalation = useSelector(
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'zorseCrmComponents' does not exist on ty... Remove this comment to see the full error message
  ({
    zorseCrmComponents: state
  }) => state.escalation);
  const escalationMeta = useSelector(
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'zorseCrmComponents' does not exist on ty... Remove this comment to see the full error message
  ({
    zorseCrmComponents: state
  }) => state.escalationMeta);
  const savingState = useSelector(
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'zorseCrmComponents' does not exist on ty... Remove this comment to see the full error message
  ({
    zorseCrmComponents: state
  }) => state.savingState);
  const escalationReasons = useMemo(() => escalationMeta.accountManagerEscalationReasons.map(reason => ({
    text: reason.description,
    value: reason.id
  })).toJS(), [escalationMeta]);
  const escalationWithOwner = escalation.setHubspotOwnerEmail(escalationMeta.accountManager ? escalationMeta.accountManager.email : '');
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [escalationMeta.accountManager && escalationMeta.accountManager.ownerType === HUBSPOTTER && /*#__PURE__*/_jsx(View, {
      marginBlockEnd: "400",
      as: "div",
      children: /*#__PURE__*/_jsx(OutOfTheOfficeAlertContainer, {
        "data-test-id": "account-manager-escalation-out-of-the-office-alert",
        hubspotterId: escalationMeta.accountManager.id,
        hubspotterName: escalationMeta.accountManager.name
      })
    }), /*#__PURE__*/_jsx(View, {
      marginBlockEnd: "400",
      as: "div",
      children: /*#__PURE__*/_jsx(ReasonForEscalationSelect, {
        "data-test-id": "reason-for-escalation-select",
        isSaving: savingState.reason,
        onSelect: option => dispatch(saveEscalation(escalationWithOwner.setReason(option).toJS(), 'reason')),
        options: escalationReasons,
        selectedOption: escalationWithOwner.reason
      })
    }), /*#__PURE__*/_jsx(NotesTextArea, {
      currentText: escalationWithOwner.notes,
      "data-test-id": "notes-text-area",
      isSaving: savingState.notes,
      onTextChange: text => dispatch(saveEscalation(escalationWithOwner.setNotes(text).toJS(), 'notes'))
    })]
  });
}
export default AccountManagerEscalation;